import script from "./Cloud_disk.vue?vue&type=script&setup=true&lang=js"
export * from "./Cloud_disk.vue?vue&type=script&setup=true&lang=js"

import "./Cloud_disk.vue?vue&type=style&index=0&id=126492c3&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-126492c3"]])

export default __exports__